import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GeneratePlanningDialogComponent } from './generate-planning-dialog.component';

@NgModule({
    providers: [],
    declarations: [
        GeneratePlanningDialogComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatTooltipModule,
        MatDividerModule,
        MatDialogModule,
        MatCheckboxModule,
    ],
    exports: [
        GeneratePlanningDialogComponent,
    ],
})
export class GeneratePlanningModule {
}
